import { useEffect, useCallback } from 'react'; // Importer useCallback
import { useCadrageStore } from '../stores/cadrageStore';

/**
 * Hook pour charger et accéder aux données principales d'un cadrage spécifique.
 * @param cadrageId - L'ID du cadrage à charger.
 * @returns Un objet contenant les données du cadrage, l'état de chargement, les erreurs éventuelles et une fonction refetch.
 */
export const useCadrageData = (cadrageId: string | undefined) => {
  // Sélectionner les états et actions nécessaires depuis le store Zustand
  const cadrageData = useCadrageStore((state) => state.cadrageData);
  const isLoading = useCadrageStore((state) => state.isLoading);
  const error = useCadrageStore((state) => state.error);
  const loadError = useCadrageStore((state) => state.loadError);
  const loadCadrageData = useCadrageStore((state) => state.loadCadrageData);
  // Optionnel: Récupérer clearCadrageData si nécessaire pour le nettoyage
  // const clearCadrageData = useCadrageStore((state) => state.clearCadrageData);

  // Effet pour charger les données lorsque l'ID du cadrage change
  useEffect(() => {
    if (cadrageId) {
      console.log(`useCadrageData: Chargement des données pour le cadrage ${cadrageId}`);
      loadCadrageData(cadrageId);
    } else {
      console.log("useCadrageData: ID de cadrage non fourni, chargement annulé.");
      // Optionnel: Nettoyer les données si l'ID devient undefined
      // clearCadrageData();
    }

    // Optionnel: Fonction de nettoyage pour effacer les données lors du démontage ou changement d'ID
    // return () => {
    //   if (cadrageId) { // Nettoyer seulement si on quitte un cadrage valide
    //      console.log(`useCadrageData: Nettoyage des données pour le cadrage ${cadrageId}`);
    //      clearCadrageData();
    //   }
    // };
  // Les dépendances incluent cadrageId et la fonction loadCadrageData (stable depuis Zustand)
  }, [cadrageId, loadCadrageData]); // Ajouter clearCadrageData si utilisé dans le cleanup

  // Fonction refetch enveloppée dans useCallback
  const refetch = useCallback(() => {
    if (cadrageId) {
        console.log(`useCadrageData: Rechargement manuel des données pour le cadrage ${cadrageId}`);
        loadCadrageData(cadrageId);
    } else {
        console.warn("useCadrageData: Tentative de rechargement sans ID de cadrage.");
    }
  }, [cadrageId, loadCadrageData]);

  // Retourner les données et les états pour utilisation dans le composant
  return {
    cadrageData,
    isLoading,
    error,
    loadError,
    refetch, // Exposer la fonction refetch
  };
};
